<template>
    <div class="web-shops">
        <div class="actions">
            <button
                class="btn"
                @click="createPopupVisible = true"
                v-if="isSupervisor"
            >{{$t('WEBSHOPS__CREATE')}}</button>
            <div class="filter">
                <custom-input
                    v-model="requestParams.Name"
                    :title="$t('WEBSHOPS__NAME')"
                    @clear="requestParams.Name = ''"
                ></custom-input>
                <button class="btn" @click="searchHandler">{{$t('WEBSHOPS__SEARCH')}}</button>
            </div>
        </div>
        <grid
            :fullGrid="true"
            :passedData="gridData"
            identificator="id"
            :columns="columns"
            :passedCount="dataCount"
            :passedPageSize="15"
            :title="$t('WEBSHOPS__TITLE')"
            @trClicked="trClickHandler"
            @pageChanged="pageChangeHandler"
        ></grid>
        <custom-snackbar
            :text="mainSnackbar.text"
            :purpose="mainSnackbar.purpose"
            v-if="mainSnackbar.visible"
            @close="mainSnackbar.visible = false"
        />
        <overlay :visible="createPopupVisible" @close="createPopupVisible = false">
            <popup :title="$t('WEBSHOPS__CREATE_WEBSHOP')" @close="createPopupVisible = false">
                <create-webshop @done="doneCreation" />
            </popup>
        </overlay>
        <overlay :visible="accountPopupVisible" @close="accountPopupVisible = false">
            <popup
                :title="$t('WEBSHOPS__CREATE_ACCOUNT')"
                expanded
                @close="accountPopupVisible = false"
            >
                <sections
                    :titles="[$t('WEBSHOPS__REVENUE'), $t('WEBSHOPS__OPERATION_HISTORY')]"
                    @changeSection="changeAccountTab"
                >
                    <webshop-account
                        :webshopID="selectedWebshopID"
                        :webshopCurrency="selectedWebshopCurrency"
                        v-if="selectedWebshopID"
                        v-show="accountTabVisible == 0"
                    />
                    <account-statement
                        v-show="accountTabVisible == 1"
                        :webshopID="selectedWebshopID"
                        :webshopCurrency="selectedWebshopCurrency"
                    />
                </sections>
            </popup>
        </overlay>
        <overlay :visible="moreActionsPopupVisible" @close="moreActionsPopupVisible = false">
            <popup :title="$t('WEBSHOPS__CREATE_ACTIONS')" @close="moreActionsPopupVisible = false" class="more-actions-popup">
                <more-actions
                    @done="doneResetPassword"
                    :webshopID="selectedWebshopID"
                    v-if="selectedWebshopID"
                />
            </popup>
        </overlay>
    </div>
</template>

<script>
import axios from '@/Helpers/AxiosInstance.js'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import Overlay from '@/components/ReusableComponents//Overlay/Overlay.vue'
import Popup from '@/components/ReusableComponents/Popup/Popup.vue'
import Sections from '@/components/ReusableComponents/Sections/Sections.vue'
import CreateWebshop from './CreateWebshop.vue'
import WebshopAccount from './WebshopAccount.vue'
import AccountStatement from './AccountStatement.vue'
import MoreActions from './MoreActions.vue'
export default {
    components: {
        Grid,
        CustomInput,
        CustomSnackbar,
        Overlay,
        Popup,
        CreateWebshop,
        WebshopAccount,
        MoreActions,
        Sections,
        AccountStatement,
    },
    created() {
        this.getData()
    },
    data() {
        return {
            gridData: [],
            requestParams: {
                Name: '',
                OrderColumn: '',
                OrderDirection: '',
                CurrentPage: 1,
                PageSize: 15,
            },
            dataCount: 0,
            searchNameInput: '',
            mainSnackbar: {
                visible: false,
                text: '',
                purpose: 'success',
            },
            createPopupVisible: false,
            accountPopupVisible: false,
            moreActionsPopupVisible: false,
            selectedWebshopID: null,
            selectedWebshopCurrency: '',
            accountTabVisible: 0,
        }
    },
    methods: {
        trClickHandler(element, e) {
            if (e.target.matches('.account-credit .add')) {
                let input = e.target.previousElementSibling.querySelector('.general-input')
                let amount = input.value
                if (!amount || amount < 0) return
                axios
                    .post('WebShop/EditWebShopCredit', {
                        webShopId: element.id,
                        amount: amount,
                    })
                    .then(resp => {
                        if (resp.data.status == 1) {
                            //success
                            this.mainSnackbar.text =
                                'Credit Added Successfully!'
                            this.mainSnackbar.purpose = 'success'
                            this.mainSnackbar.visible = true
                            input.value = ''
                            this.getData()
                        } else {
                            this.showCreditAddError(resp.data.status)
                        }
                    })
                    .catch(() => {
                        this.showCreditAddError()
                    })
            } else if (e.target.matches('.deduct-credit .deduct')) {
                let input = e.target.previousElementSibling.querySelector('.general-input')
                let amount = input.value
                if (!amount || amount < 0) return
                axios
                    .post('WebShop/EditWebShopCredit', {
                        webShopId: element.id,
                        amount: amount * -1,
                    })
                    .then(resp => {
                        if (resp.data.status == 1) {
                            //success
                            this.mainSnackbar.text =
                                'Credit Deducted Successfully!'
                            this.mainSnackbar.purpose = 'success'
                            this.mainSnackbar.visible = true
                            input.value = ''
                            this.getData()
                        } else {
                            this.showCreditDeductError(resp.data.status)
                        }
                    })
                    .catch(() => {
                        this.showCreditDeductError()
                    })
            } else if (e.target.matches('.btn.account')) {
                this.selectedWebshopID = element.id
                this.selectedWebshopCurrency = element.currencyCode
                this.accountTabVisible = 0
                this.accountPopupVisible = true
            } else if (e.target.matches('.switcher.lock')) {
                let isActive = e.target.classList.contains('active')
                if (isActive) e.target.classList.remove('active')
                else e.target.classList.add('active')
                axios
                    .post('WebShop/LockUnlockWebShop', {
                        webShopId: element.id,
                        locked: !element.locked,
                    })
                    .then(resp => {
                        if (resp.data.status == 1) {
                            this.showSuccess(
                                `Successfully ${
                                    element.locked ? 'Unlocked!' : 'Locked!'
                                }`
                            )
                        } else {
                            this.showError(resp.data.status)
                        }
                        this.getData()
                    })
                    .catch(() => this.showError())
            } else if (e.target.matches('.switcher.enable')) {
                let isActive = e.target.classList.contains('active')
                if (isActive) e.target.classList.remove('active')
                else e.target.classList.add('active')
                axios
                    .post('WebShop/EditWebShopBonusEnabled', {
                        webShopId: element.id, 
                        bonusEnabled: !element.bonusEnabled
                    })
                    .then(resp => {
                        if (resp.data.status == 1) {
                            this.showSuccess(
                                `Successfully ${
                                    element.bonusEnabled ? 'Disabled!' : 'Enabled!'
                                }`
                            )
                        } else {
                            this.showError(resp.data.status)
                        }
                        this.getData()
                    })
                    .catch(() => this.showError())
            } else if (e.target.matches('.more')) {
                this.selectedWebshopID = element.id
                this.moreActionsPopupVisible = true
            }
        },
        getData() {
            axios
                .get('WebShop/GetWebShops', {
                    params: { ...this.requestParams },
                })
                .then(resp => {
                    this.gridData = resp.data.response
                    this.dataCount =
                        resp.data.response.length > 0
                            ? resp.data.response[0].count
                            : 0
                })
        },
        showCreditAddError(status) {
            this.mainSnackbar.text = 'An Error Occured While Adding Credit!'
            this.mainSnackbar.purpose = 'error'
            this.mainSnackbar.visible = true
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code)
                this.mainSnackbar.text = this.$t('STATUS-CODE__' + code.value)
        },
        showCreditDeductError(status) {
            this.mainSnackbar.text = 'An Error Occured While Deducting Credit!'
            this.mainSnackbar.purpose = 'error'
            this.mainSnackbar.visible = true
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code)
                this.mainSnackbar.text = this.$t('STATUS-CODE__' + code.value)
        },
        doneCreation(result) {
            this.createPopupVisible = false
            this.mainSnackbar.visible = true
            this.mainSnackbar.purpose = result.purpose
            if (result.purpose == 'success') {
                this.mainSnackbar.text = 'Successfully Created Webshop!'
                this.getData()
            } else {
                this.mainSnackbar.text =
                    'An Error Occured While Creating Webshop!'
            }
        },
        showSuccess(text) {
            this.mainSnackbar.visible = true
            this.mainSnackbar.text = text
            this.mainSnackbar.purpose = 'success'
        },
        showError(status) {
            this.mainSnackbar.visible = true
            this.mainSnackbar.text = 'An Error Has Occurred!'
            this.mainSnackbar.purpose = 'error'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code)
                this.mainSnackbar.text = this.$t('STATUS-CODE__' + code.value)
        },
        doneResetPassword(data) {
            if (data.purpose == 'success') {
                this.showSuccess(data.text)
            } else if (data.purpose == 'error') {
                this.showError(data.text)
            }
            this.moreActionsPopupVisible = false
        },
        changeAccountTab(index) {
            this.accountTabVisible = index
        },
        pageChangeHandler(page) {
            this.requestParams.CurrentPage = page
            this.getData()
        },
        searchHandler() {
            this.requestParams.CurrentPage = 1
            this.getData()
        },
    },
    computed: {
        columns() {
            var columns = [
                {
                    title: this.$t('WEBSHOPS__WEBSHOP_NAME'),
                    key: 'name',
                    customTemplate: (item, val) =>
                        val
                            ? `${item.calculatedName} (${val})`
                            : item.calculatedName,
                },
                {
                    title: this.$t('WEBSHOPS__LOGIN_USERNAME'),
                    key: 'loginUserName',
                    customTemplate: (item, val) => val ? val : '-',
                },
                {
                    title: this.$t('WEBSHOPS__AVAILABLE_CREDIT_LINE'),
                    key: 'availableCredit',
                    customTemplate: (item, val) => {
                        return val + ' ' + item.currencyCode
                    },
                },
                {
                    title: this.$t('WEBSHOPS__FAILED_LOGINS'),
                    key: 'failedLogins',
                },
                {
                    title: this.$t('WEBSHOPS__ACCOUNT_CREDIT'),
                    key: 'accountCredit',
                    plainColumn: true,
                    customTemplate: (item) => {
                        return `
                            <div class="account-credit">
                                <label>
                                    <span class="currency">${item.currencyCode}</span>
                                    <input type="text" class="general-input" />
                                </label>
                                <button class="btn add">${this.$t(
                                    'WEBSHOPS__ADD'
                                )}</button>
                            </div>
                        `
                    },
                },
                {
                    title: 'Deduct Credit',
                    key: 'deductCredit',
                    plainColumn: true,
                    customTemplate: (item) => {
                        return `
                        <div class="deduct-credit">
                            <label>
                                <span class="currency">${item.currencyCode}</span>
                                <input type="text" class="general-input" />
                            </label>
                            <button class="btn deduct">${this.$t(
                                'WEBSHOPS__DEDUCT'
                            )}</button>
                        </div>
                        `
                    },
                },
                {
                    title: 'Locked',
                    key: 'locked',
                    plainColumn: true,
                    customTemplate: (item, val) => {
                        if (val) {
                            return '<div class="switcher active lock"></div>'
                        } else {
                            return '<div class="switcher lock"></div>'
                        }
                    },
                },
                {
                    title: 'Bonus Enabled',
                    key: 'bonusEnabled',
                    plainColumn: true,
                    customTemplate: (item, val) => {
                        if(this.isSupervisor) {
                            if (val) {
                                return '<div class="switcher active enable"></div>'
                            } else {
                                return '<div class="switcher enable"></div>'
                            }
                        }
                        else {
                            return val ? 'YES' : 'NO'
                        }
                    },
                },
                {
                    title: '',
                    key: '',
                    plainColumn: true,
                    customTemplate: () => {
                        return `
                        <button class="btn btn-filter account">${this.$t(
                            'WEBSHOPS__ACCOUNT'
                        )}</button>
                        `
                    },
                },
                {
                    title: '',
                    key: 'more',
                    plainColumn: true,
                    customTemplate: () => {
                        return `
                            <div class="more">
                                <i class="material-icons more">build</i>
                                <span>${this.$t('WEBSHOPS__SETTINGS')}</span>
                            </div>
                        `
                    },
                },
            ]
            var supervisorColumns = [
                'accountCredit',
                'deductCredit',
                'locked',
                // 'more',
            ]
            if (!this.isSupervisor) {
                columns = columns.filter(
                    el => !supervisorColumns.includes(el.key)
                )
            }
            return columns
        },
        isSupervisor() {
            return this.$store.state.shop != null
        },
        statusCodes() {
            return this.$store.state.statusCodes
        },
    },
}
</script>

<style scoped lang="scss">
.actions {
    margin-bottom: 15 * $rem;
    display: flex;
    font-size: 16 * $rem;

    .filter {
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40 * $rem;

        .btn {
            margin-left: 15 * $rem;
        }
    }

    .btn {
        font-size: 16 * $rem;
    }
}

/deep/ .account-credit,
/deep/ .deduct-credit {
    display: flex;
    height: 34 * $rem;

    label {
        position: relative;

        input {
            width: 139 * $rem;
            margin-right: 15 * $rem;
        }
        .currency {
            position: absolute;
            right: 25 * $rem;
            top: 8 * $rem;
            margin: auto;
            color: rgb(180, 180, 180);
        }
    }

    .btn {
        width: 72 * $rem;
        min-width: 72 * $rem;
        min-height: initial;
    }
}

/deep/ .more {
    cursor: pointer;
    width: 75 * $rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;

    span {
        font-size: 12 * $rem;
        margin-top: 5 * $rem;
    }
}

/deep/ .btn-filter {
    width: 90 * $rem;
    height: 34 * $rem;
    min-width: initial;
    min-height: initial;
}

/deep/ tr td {
    max-width: initial !important;
}

/deep/ .more-actions-popup {
    min-height: 70vh;
}

@media only screen and (max-width: 405px) {
    .actions {
        display: initial;

        .filter {
            margin: 15 * $rem 0;
            justify-content: flex-start;
        }
    }
}
</style>